<template>
  <div class="user_repurchase_pge">
    <h1>用户充值数据报表</h1>
    <div class="user-options clearfix">
      <DatePicker2 @datePickedChange="datePickedChange"></DatePicker2>
      <el-select
        style="width: 160px"
        v-model="curChannel.selectValue"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="dateValue"
        value-format="yyyy-MM-dd"
        disabledDate="disabledDate"
        type="date"
        :picker-options="pickerOptions"
        placeholder="注册时间"
      >
      </el-date-picker>
      <el-input v-model="rid" placeholder="用户uid" style="width: 200px" />
      <el-button type="primary" @click="doInquery">查询</el-button>
      <el-button type="primary" @click="downloadReport">下载</el-button>
    </div>
    <div class="display-type">
      <div v-loading="loading">
        <CustomTable1
          :tableList="tableList"
          :options="tableOptions"
          class="table"
          :pageSize="10"
          :total="pageInfo.total"
          :currentPage="pageInfo.currentPage"
          @handleCurrentChange="handleCurrentChange"
        ></CustomTable1>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTable1 from '../../components/CustomTable1'
import DatePicker2 from '../../components/DatePicker2'

export default {
  components: {
    CustomTable1,
    DatePicker2
  },
  data() {
    return {
      pageInfo: {
        total: 0,
        currentPage: 1
      },
      curChannel: {
        selectValue: 'total',
        content: ''
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      channels: this.$store.state.channels,
      dateValue: null,
      rid: '',
      datePicked: [
        this.$store.getters.dateTwoDayBefore,
        this.$store.getters.dateOneDayBefore
      ],
      tableOptions: {
        defaultSort: {
          prop: 'period',
          order: 'ascending'
        },
        theader: [
          {
            name: 'period',
            label: '充值周期',
            sortable: true,
            fixed: true,
            width: '250px'
          },
          {
            name: 'rid',
            label: '用户id',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'registerTime',
            label: '注册时间',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'country',
            label: '国家',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'language',
            label: '系统语言',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'channel',
            label: '平台',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'email',
            label: '账号邮箱',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'payMoney',
            label: '总充值金额数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'periodPayMoney',
            label: '日期周期内充值金额数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'periodPayGold',
            label: '日期周期内充值金币数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'historyFirstPayDate',
            label: '历史第一次充值日期',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'firstPayGold',
            label: '第一次充值金币数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'firstPayTime',
            label: '第一次充值时间',
            sortable: true,
            fix: true,
            width: '250px'
          },
          {
            name: 'secondPayGold',
            label: '第二次充值金币数',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'secondPayTime',
            label: '第二次充值时间',
            sortable: true,
            fix: true,
            width: '250px'
          },
          {
            name: 'thirdPayGold',
            label: '第三次充值金币数',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'thirdPayTime',
            label: '第三次充值时间',
            sortable: true,
            fix: true,
            width: '250px'
          },
          {
            name: 'fourthPayGold',
            label: '第四次充值金币数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'fourthPayTime',
            label: '第四次充值时间',
            sortable: true,
            fix: true,
            width: '250px'
          },
          {
            name: 'fifthPayGold',
            label: '第五次充值金币数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'fifthPayTime',
            label: '第五次充值时间',
            sortable: true,
            fix: true,
            width: '250px'
          }
        ]
      },
      tableList: [],
      loading: true
    }
  },
  beforeCreate() {},
  created() {
    this.getList()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    datePickedChange(date) {
      this.datePicked = date
    },
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val
      this.getList()
    },
    //获取视频通话数据
    getList() {
      this.loading = true
      this.$axios({
        type: 'get',
        url: this.$store.getters.path.reports_pay_repurchase,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          start: this.datePicked[0],
          end: this.datePicked[1],
          channel: this.curChannel.selectValue,
          registerTime: this.dateValue,
          rid: this.rid,
          page: this.pageInfo.currentPage
        }
      })
        .then(
          res => {
            if (res.data.code === 0) {
              this.tableListBuild(res.data.data.data)
              this.pageInfo.total = res.data.data.total
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
              this.$router.push(this.$route.query.redirect || '/login')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          },
          err => {
            this.$message({
              showClose: true,
              message: '请求错误:' + err,
              type: 'error'
            })
          }
        )
        .then(() => {
          this.loading = false
        })
    },
    //表格数据
    tableListBuild(data) {
      this.tableList = data
    },
    doInquery() {
      this.getList()
    },
    // 生成并下载主播excel
    downloadReport() {
      window.location.href =
        this.$store.getters.path.reports_pay_download_repurchase +
        '?token=' +
        this.token +
        '&start=' +
        this.datePicked[0] +
        '&end=' +
        this.datePicked[1] +
        '&channel=' +
        this.curChannel.selectValue +
        '&registerTime=' +
        this.dateValue +
        '&rid=' +
        this.rid +
        '&username=' +
        this.username
    }
  }
}
</script>


<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.user_repurchase_pge {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
</style>
